import React from "react";

const Section = ({ title, children }) => {
  return (
    <section className="container py-5 px-3 bg-gray-50 rounded-2xl shadow mb-5">
      <div>
        <h2 className="text-xl">{title}</h2>
        <hr className="border-gray-300 mb-5" />
        {children}
      </div>
    </section>
  );
};

export { Section };
